export default __webpack_public_path__ + "static/media/Sumukha.62dc5b96.png";